import { input } from '../../tokens/component';
import { state, effects } from '../../tokens/semantic';

const { checkbox } = input.selection;

const MuiCheckbox = {
    defaultProps: {
        size: 'medium',
    },
    styleOverrides: {
        root: {
            paddingLeft: 0,
            color: checkbox.color.off.default,
            '&:hover': {
                color: checkbox.color.off.hover,
                backgroundColor: 'transparent',
            },
            '&.Mui-checked': {
                color: checkbox.color.on.default,
                '&:hover': {
                    color: checkbox.color.on.hover,
                    backgroundColor: 'transparent',
                },
            },
            '&.MuiCheckbox-indeterminate': {
                color: checkbox.color.on.default,
                '&:hover': {
                    color: checkbox.color.on.hover,
                    backgroundColor: 'transparent',
                },
            },
            '&.Mui-focusVisible .MuiSvgIcon-root': {
                outline: `${state.outline.weight.focus.md} solid ${state.outline.color.focus}`,
                outlineOffset: state.outline.offset.focus.sm,
                borderRadius: effects.radius.sm,
            },
            '&.Mui-disabled': {
                opacity: checkbox.state.disabled.opacity,
            },
        },
        sizeSmall: ({ theme }) => ({
            '& .MuiSvgIcon-root': {
                fontSize: checkbox.size.sm,
            },
            [theme.breakpoints.down('sm')]: {
                '& .MuiSvgIcon-root': {
                    fontSize: checkbox.size.lg,
                },
            },
        }),
        sizeMedium: ({ theme }) => ({
            '& .MuiSvgIcon-root': {
                fontSize: checkbox.size.md,
            },
            [theme.breakpoints.down('sm')]: {
                '& .MuiSvgIcon-root': {
                    fontSize: checkbox.size.lg,
                },
            },
        }),
    },
    variants: [
        {
            props: { size: 'large' },
            style: {
                '& .MuiSvgIcon-root': {
                    fontSize: checkbox.size.lg,
                },
            },
        },
    ],
};

export default MuiCheckbox;
